export const COOKIE_EXPIRE_DAYS = 7;
export const COOKIE_NAME_PREFIX = "";
export const COOKIE_PATH = "/";
